export class HonorType {
    honorTypeID: number;
    name: string;
}                                                    